<template>
  <div class="quiz-text mb-auto">
    <p><strong>{{ displayNumber }}</strong> {{ $t("quiz.instructions") }}</p>

    <div>
      <img
        class="first"
        :src="image_0"
        :class="{ active: isSelected(0), answered }"
        @click="select(0)"
      >
      <img
        :src="image_1"
        :class="{ active: isSelected(1), answered }"
        @click="select(1)"
      >
    </div>

    <div v-if="answered">
      <p v-if="answer_correct">
        <strong class="correct">{{ $t("quiz.correct") }}</strong>
        {{ $t("quiz.genuine") }} {{ $t("quiz.questions." + number + ".genuine") }}
      </p>
      <p v-else>
        <strong class="incorrect">{{ $t("quiz.incorrect") }}</strong>
        {{ $t("quiz.counterfeit") }}{{ $t("quiz.questions." + number + ".counterfeit") }}
      </p>
    </div>
  </div>
</template>

<script>

const quizImages = require.context('@/assets/quiz/questions/', false);

export default {
  props: {
    displayNumber: {
      type: Number,
      required: true,
    },
    number: {
      type: Number,
      required: true,
    },
    correct: {
      type: Number,
      required: true,
    },
    filetype: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      selected: null,
    };
  },
  computed: {
    image_0() { return quizImages(`./${this.number}-o1.${this.filetype}`); },
    image_1() { return quizImages(`./${this.number}-o2.${this.filetype}`); },
    answered() { return this.selected !== null; },
    answer_correct() { return this.selected !== this.correct; },
  },
  methods: {
    select(n) {
      if (!this.answered) {
        this.selected = n;
        // Emit answered event with boolean 'correctness' parameter
        this.$emit('answered', this.answer_correct);
      }
    },
    isSelected(n) {
      return this.selected === n;
    },
  },
};
</script>

<style scoped lang="scss">
  .quiz-text {
    padding: 0;
    border: 0;

    h3 {
      padding: 0;
      margin: 0 0 12px 0;
    }

    img {
      // display: inline;
      width: 240px;
      height: 240px;
      &.first  {
        margin-right: 8px;
      }
      margin:0 0 12px 0;

      @media (max-width: 768px) {
        width: 180px;
        height: 180px;
        &.first  {
          margin-right: 6px;
        }
      }

      @media (max-width: 576px) {
        width: 138px;
        height: 138px;
        &.first {
          margin-right: 6px;
        }
      }

      cursor: pointer;
      &.answered {
        cursor: default;

        &:hover {
          border: none;
        }
      }

      &:hover {
        border: 3px solid #fff;
      }

      &.active, &.active:hover {
        border: 3px solid #fff;
      }

    }

    .incorrect {
      color: #ee0000;
    }
    .correct {
      color: #03e132;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/quiz/QuizQuestion.vue